import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import zhTW from "./zh-TW.json";
import ja from "./ja.json";
import fr from "./fr.json";
import de from "./de.json";
import pt from "./pt.json";
import it from "./it.json";
import nl from "./nl.json";
import ar from "./ar.json";

const supportedLanguages = [
  "en",
  "zh-TW",
  "ja",
  "fr",
  "de",
  "pt",
  "it",
  "nl",
  "ar",
];

const getBrowserLanguage = () => {
  const browserLanguages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  for (const browserLanguage of browserLanguages) {
    const normalizedLanguage = browserLanguage?.replace("_", "-");
    const exactMatch = supportedLanguages.find(
      (language) =>
        language.toLowerCase() === normalizedLanguage?.toLowerCase(),
    );

    if (exactMatch) return exactMatch;

    const baseLanguage = normalizedLanguage?.split("-")[0].toLowerCase();
    if (baseLanguage === "zh") return "zh-TW";
    if (supportedLanguages.includes(baseLanguage)) return baseLanguage;
  }

  return "en";
};

const storedLanguage = localStorage.getItem("staywork_language");
const initialLanguage = supportedLanguages.includes(storedLanguage)
  ? storedLanguage
  : getBrowserLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "zh-TW": { translation: zhTW },
    ja: { translation: ja },
    fr: { translation: fr },
    de: { translation: de },
    pt: { translation: pt },
    it: { translation: it },
    nl: { translation: nl },
    ar: { translation: ar },
  },
  lng: initialLanguage,
  supportedLngs: supportedLanguages,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
i18n.on("languageChanged", (language) => {
  localStorage.setItem("staywork_language", language);
  document.documentElement.lang = language;
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  document.title = i18n.t("brand.pageTitle", { lng: language });
});
document.documentElement.lang = initialLanguage;
document.documentElement.dir = initialLanguage === "ar" ? "rtl" : "ltr";
document.title = i18n.t("brand.pageTitle", { lng: initialLanguage });
export default i18n;
